import { useTransition, config } from "@react-spring/web";

import { OrderItem } from "../CustomerTab/schema";

export const useOrderItemsTransitions = (orderItems: OrderItem[]) => {
  return useTransition(orderItems, {
    keys: (oi) => oi.uuid,
    config: config.gentle,
    from: {
      opacity: 0,
      // maxHeight: "100%",
      // transform: "translate3d(-25%, 0px, 0px)",
    },
    enter: {
      opacity: 1,
      // maxHeight: "100%",
      // transform: "translate3d(0%, 0px, 0px)",
      // transform: "translate3d(0%, 0px, 0px)",
    },
    leave: {
      // transform: "translate3d(100%, 0px, 0px)",
      // transform: "scale(0%)",
      opacity: 0,
      config: config.default,
    },
  });
};
